import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { ViewFileIcon } from "../../../../Icons/ViewFileIcon";
import { DownloadIcon } from "../../../../Icons/DownloadIcon";
import GetJobId from "../../../../_utilities/GetJobId";
import { GetTimeZone } from "../../../../_utilities/GetTimeZone";
import {
  GetUserId,
  GetUserInfo,
  getAttributes,
  getUserDetails,
} from "../../../../_utilities/getUserInfo";
import { updateSnackbar } from "../../../../_redux/SnackbarSlice";
import * as _ser from "../../../../_redux/_services/ApplicantsSlice";
import { decrypt } from "../../../../_utilities/_encryptDecryptHelper";
import { openDocumentInNewTab } from "../../../../_utilities/utilities";
import {
  Box,
  Button,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
} from "@mui/material";
import AddApplicantDetailsDocuments from "./AddApplicantDetailsDocuments";
import DetailCard from "../../../../components/DetailCard/DetailCard";
import Pagination from "../../../../components/DynamicTable/Pagination";
import { DashboardPlusicon } from "../../../../Icons/DashboardPlusicon";
import DeleteIcon from "@mui/icons-material/Delete";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import WarningPopup from "../../../../components/WarningPopup/WarningPopup";

import "./ApplicantDetailsDocuments.css";

const CARDS_PER_PAGE = 6;

const initalState = { data: null, message: "", isloader: true };

const ApplicantDetailsDocuments = ({
  data,
  selectedAppliant,
  onReceiveProps,
}) => {
  const [open, setOpen] = useState(false);
  const [docObj, setDocObj] = useState("");
  const [DocName, setDocName] = useState("");
  const [documents, setDocuments] = useState([]);
  const [actionType, setActionType] = useState("");
  const [isLoadDoc, setIsLoadDoc] = useState(false);
  const [HandlerType, setHandlerType] = useState("");
  const [previewType, setPreviewType] = useState("");
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [docToDelete, setDocToDelete] = useState(null);
  const [warningPopupDetails, setWarningPopupDetails] = useState({
    title: "",
    btnName: "",
    type: "",
  });

  const warningPopupEnum = {
    DELETE: {
      title: "Are you sure you want to delete this document?",
      btnName: "Delete",
      type: "delete",
    },
  };
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [isValidUser, setIsValidUser] = useState(false);
  const [fileExtention, setFileExtention] = useState("");
  const [isRightSidePannel, setIsRightSidePannel] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const JobId = GetJobId();

  const code = useSelector((state) => state.DeleteDocuments.data);
  const updateResumeData = useSelector((store) => store.UploadResume);
  const docData = useSelector((state) => state.Downloaddocument.data);
  const GetDocumentscode = useSelector((state) => state.GetDocuments.code);

  const DocId = useSelector((state) => state.UploadDocuments.docId);
  const selectedJobDetails = useSelector(
    (state) => state.SetSelectedJobDetails.data,
  );
  const { storedApplicant } = useSelector((state) => state.SelectedApplicant);

  useEffect(() => {
    async function processApplicantjobs() {
      if (
        DocId &&
        !location.state?.isAssociatedApplicant &&
        selectedJobDetails?.length > 0
      ) {
        let userInfo = await GetUserInfo();
        let userId = await getAttributes();

        let data = {
          id: storedApplicant.id,
          jobCode: selectedJobDetails[0].jobCode,
          docId: DocId,
          firstName: userId[0].firstName,
          lastName: userId[0].lastName,
          portalassociatedJobs: "associatedJobs",
          status: "Associated",
          source: "ATS",
          submittedBy: userInfo[0].userId,
          userId: userId[0].userId,
        };
        let jobs = [];
        if (selectedJobDetails && selectedJobDetails.length > 0) {
          selectedJobDetails.forEach((job) => {
            let obj = {};
            obj["jobId"] = job.id;
            obj["jobCode"] = job.jobCode;
            jobs.push(obj);
          });
        }
        data["jobs"] = jobs.length > 0 ? jobs : [];
        dispatch(
          _ser.addAssociatedjobsAsync(storedApplicant.id, data, "posting"),
        );
        dispatch(_ser.setSelectedJobDetailsStartReducer(initalState));

        dispatch(_ser.uploadDocumentsStartReducer(initalState));
      }
    }
    processApplicantjobs();
  }, [DocId]);

  useEffect(() => {
    if (GetDocumentscode === 404) {
      setIsValidUser(true);
    }
  }, [GetDocumentscode]);

  useEffect(() => {
    if (isLoadDoc === true) {
      setIsLoadDoc(false);
      onReceiveProps("documents");
    }
  }, [isLoadDoc]);

  useEffect(() => {
    if (data !== null) {
      setDocuments(data);
      setCurrentPage(1);
    }
  }, [data]);

  // ─── Paginated data ───
  const paginatedDocs = useMemo(() => {
    const start = (currentPage - 1) * CARDS_PER_PAGE;
    return documents.slice(start, start + CARDS_PER_PAGE);
  }, [documents, currentPage]);

  // ─── Build card body fields for each document ───
  const buildDocFields = useCallback((doc) => {
    const fields = [];

    fields.push({
      label: "Sourced from",
      value: doc.resumesource || "-",
      boldValue: true,
      separator: " ",
    });

    const iconType =
      (doc.fileType || "").toLowerCase() === "doc" ||
      (doc.fileType || "").toLowerCase() === "docx"
        ? "doc"
        : "pdf";
    fields.push({
      icon: iconType,
      value: doc.documentName || doc.name || "-",
    });

    fields.push({
      label: "Uploaded by",
      value: doc.uploadedBy || "-",
      boldValue: true,
      separator: "  ",
    });

    fields.push({
      value: doc.createdDate || "-",
    });

    return fields;
  }, []);

  // ─── Build footer actions for each document ───
  const buildDocActions = useCallback(
    (doc) => [
      {
        key: "view",
        icon: <ViewFileIcon />,
        label: "View",
        tooltip: "View",
        onClick: () => {
          DownloadFileFromS3(doc, "view");
          setHandlerType("view");
          setIsRightSidePannel(true);
        },
      },
      {
        key: "download",
        icon: <DownloadIcon />,
        label: "Download",
        tooltip: "Download",
        onClick: () => DownloadFileFromS3(doc, "download"),
      },
      ...((doc.docType || doc.documentType || "Resume").toLowerCase() ===
      "resume"
        ? [
            {
              key: "star",
              icon:
                doc.primaryResume === 1 ? (
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/assests/img/primary-star-inside-circle.svg"
                    }
                    alt="Primary"
                    style={{ width: 16, height: 16 }}
                  />
                ) : (
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/assests/img/star-inside-circle.svg"
                    }
                    alt="Mark as Primary"
                    style={{ width: 16, height: 16 }}
                  />
                ),
              tooltip:
                doc.primaryResume === 1
                  ? "Primary Document"
                  : "Mark as Primary",
              onClick:
                doc.primaryResume === 1
                  ? undefined
                  : () => {
                      setOpen(true);
                      setDocObj(doc);
                    },
            },
          ]
        : []),
      {
        key: "openNew",
        icon: (
          <img
            src={process.env.PUBLIC_URL + "/assests/img/newtabIcon.svg"}
            alt="Primary"
            style={{ width: 14, height: 14 }}
          />
        ),
        tooltip: "Open in new tab",
        onClick: () => DownloadFileFromS3(doc, "viewDocumentNewPage"),
      },
      {
        key: "delete",
        icon: <DeleteIcon style={{ width: 18, height: 18 }} />,
        tooltip: "Delete",
        onClick: () => {
          setDocToDelete(doc);
          setWarningPopupDetails(warningPopupEnum.DELETE);
          setShowDeleteConfirm(true);
        },
      },
    ],
    [selectedAppliant],
  );

  const handleClose = (e) => {
    e.stopPropagation();
    setOpen(false);
    navigate(location.pathname + location.search, {
      state: { selectedApplicant: selectedAppliant, isDocument: true },
    });
  };

  const handleActionClick = (data, type) => {
    if (type === "confirm") {
      localStorage.setItem("isPrimaryDoc", true);
      markPrimaryHandler(docObj);
    }
  };

  const markPrimaryHandler = async (docObj) => {
    const userInfo = await getUserDetails();
    const customerId = await GetUserId();
    let formData = new FormData();
    formData.append("customerId", customerId);
    formData.append("userId", userInfo.userId);
    formData.append("docId", docObj.id);
    dispatch(_ser.uploadResumeAsync(formData, true));
  };

  useEffect(() => {
    if (updateResumeData.code === 209 && updateResumeData.updatedata) {
      let obj = { ...updateResumeData.updatedata[0] };
      obj["message"] = updateResumeData.message;
      obj["id"] = updateResumeData.id;
      obj["oldApplicantName"] = updateResumeData.oldApplicantName;
      dispatch(_ser.uploadResumeStartReducer(initalState));
      const state = { applicant: obj, docId: docObj.id, isOverwriteEdit: true };
      onReceiveProps("edit", state);
    } else if (updateResumeData.code === 210) {
      setOpen(false);
      dispatch(
        updateSnackbar({ type: "error", message: updateResumeData.message }),
      );
      let data = [...documents];
      data.forEach((list) => {
        list["isChecked"] = false;
      });
      setDocuments(data);
      dispatch(_ser.uploadResumeStartReducer(initalState));
    }
  }, [updateResumeData]);

  const DeleteDocuments = async (object) => {
    let obj = { file_ids: [object.id.toString()] };
    dispatch(_ser.deleteDocumentsAsync(selectedAppliant?.id, obj));
  };

  useEffect(() => {
    if (code === 200) {
      onReceiveProps("documents");
      dispatch(_ser.deleteDocumentsStartReducer(initalState));
    }
  }, [code]);

  const DownloadFileFromS3 = async (object, type) => {
    const actiontypeToApi =
      type === "Download" || type === "download" ? "download" : "preview";
    const actiontype =
      type === "Download" || type === "download"
        ? "download"
        : type === "view"
          ? "preview"
          : type;
    setSelectedDoc(object);
    setActionType(actiontype);
    setDocName(object.path);
    setFileExtention(object.fileType);
    dispatch(
      _ser.downloaddocumentAsync(
        selectedAppliant?.id,
        actiontypeToApi,
        object.id,
      ),
    );
  };

  const guessNameFromUrl = (url) => {
    try {
      return decodeURIComponent(
        new URL(url).pathname.split("/").pop() || "download",
      );
    } catch {
      return "download";
    }
  };

  useEffect(() => {
    if (!docData) return;

    const run = async () => {
      try {
        if ((actionType || "").toLowerCase() === "download") {
          if (typeof docData === "string") {
            const filename =
              selectedDoc?.fileName || DocName || guessNameFromUrl(docData);
            const res = await fetch(docData, {
              cache: "no-store",
              credentials: "omit",
            });
            const blob = await res.blob();
            const href = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = href;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(href);
          } else {
            const filename =
              selectedDoc?.fileName ||
              DocName ||
              `document.${(fileExtention || "pdf").toLowerCase()}`;
            const blob =
              docData instanceof Blob ? docData : new Blob([docData]);
            const href = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = href;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(href);
          }
        } else if (actionType === "viewDocumentNewPage") {
          openDocumentInNewTab(docData, fileExtention);
        } else {
          setPreviewType(docData);
        }
      } finally {
        dispatch(_ser.downloaddocumentStartReducer(initalState));
      }
    };

    run();
  }, [docData]);

  const onReceivePropsHandler = (pannel, load, type) => {
    if (type !== "") {
      setIsRightSidePannel(pannel);
      setIsLoadDoc(load);
    } else {
      DownloadFileFromS3(pannel, load);
    }
  };

  return (
    <>
      {/* ── Action Bar ── */}
      <div
        className="detail-card-search"
        style={{ justifyContent: "flex-end" }}
      >
        <button
          type="button"
          className="detail-card-search__action-btn"
          onClick={() => {
            setIsRightSidePannel(true);
            setHandlerType("New document");
          }}
        >
          <DashboardPlusicon width={22} height={22} />
          <span>New Document</span>
        </button>
      </div>

      {/* ── Card Grid ── */}
      <div id="applicantDocs">
        {paginatedDocs.length > 0 ? (
          <div className="detail-card-grid detail-card-grid--docs">
            {paginatedDocs.map((doc, idx) => (
              <DetailCard
                key={doc.id || idx}
                headerTitle={doc.docType || doc.documentType || "Resume"}
                badge={null}
                bodyFields={buildDocFields(doc)}
                footerActions={buildDocActions(doc)}
                testId={`doc-card-${doc.id || idx}`}
              />
            ))}
          </div>
        ) : (
          <div className="detail-card-empty">
            <img
              src={process.env.PUBLIC_URL + "/assests/nodata.svg"}
              alt="No data"
            />
            No documents found
          </div>
        )}

        {/* ── Pagination ── */}
        <Pagination
          currentPage={currentPage}
          totalCount={documents.length}
          pageSize={CARDS_PER_PAGE}
          onPageChange={setCurrentPage}
          className="detail-card-pagination"
        />
      </div>

      {isRightSidePannel ? (
        <AddApplicantDetailsDocuments
          HandlerType={HandlerType}
          JobId={selectedAppliant?.id}
          previewType={previewType}
          DocName={DocName}
          fileExtention={fileExtention}
          onReceivePropsHandler={onReceivePropsHandler}
        />
      ) : (
        <></>
      )}

      <Dialog
        open={open}
        keepMounted
        onClose={(e) => {handleClose(e)}}
        aria-describedby="alert-dialog"
        style={{ marginTop: "-26%" }}
      >
        <Box sx={{ width: "395px" }}>
          <DialogTitle className="diabtn">
            Confirm
            <img
              src={process.env.PUBLIC_URL + "/assests/img/close.svg"}
              alt=""
              className="primaryCloseicon"
              onClick={(e) => {handleClose(e)}}
            />
          </DialogTitle>
          <DialogContent>
            <DialogContentText className="" id="primary-dialog">
              <p className="btntext">
                Are you sure you want to mark this document as primary?
              </p>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="alert-actionbtns">
            <Button onClick={(e) => {handleClose(e)}}>
              <Link href="#" color="#000" underline="always">
                Cancel
              </Link>
            </Button>
            <Button onClick={() => handleActionClick(null, "confirm")}>
              Confirm
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
      <WarningPopup
        open={showDeleteConfirm}
        handleClose={() => setShowDeleteConfirm(false)}
        handleConfirm={() => {
          DeleteDocuments(docToDelete);
          setShowDeleteConfirm(false);
        }}
        details={warningPopupDetails}
      />
    </>
  );
};

export default ApplicantDetailsDocuments;
